import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { loading } from "@stores/vars";
import { useOnLoadImages } from "@hooks/useOnLoadImages";
import playSound from "@/sound";
import anime from "animejs";

const Wrap = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  transition: opacity 0.3s;
  opacity: 0;

  &.on {
    opacity: 1;
  }

  .text {
    position: absolute;
    left: 50%;
    margin-left: -310px;
    top: 240px;
    width: 621px;
    height: 102px;
  }

  .char {
    position: absolute;
    left: 50%;
    margin-left: -300px;
    top: 380px;
    width: 600px;
    height: 600px;
  }

  .effect {
    position: absolute;
    left: 50%;
    margin-left: -457px;
    top: 460px;
    width: 894px;
    height: 426px;
  }
`;

const ms = [
  require("@data/assets/_static/sounds/m1.mp3"),
  require("@data/assets/_static/sounds/m2.mp3"),
  require("@data/assets/_static/sounds/m3.mp3"),
  require("@data/assets/_static/sounds/m4.mp3"),
];
const ws = [
  require("@data/assets/_static/sounds/w1.mp3"),
  require("@data/assets/_static/sounds/w2.mp3"),
  require("@data/assets/_static/sounds/w3.mp3"),
  require("@data/assets/_static/sounds/w4.mp3"),
];

const char_m = [
  require("@data/assets/_static/welcome_m1.png"),
  require("@data/assets/_static/welcome_m2.png"),
  require("@data/assets/_static/welcome_m3.png"),
  require("@data/assets/_static/welcome_m4.png"),
];
const char_w = [
  require("@data/assets/_static/welcome_w1.png"),
  require("@data/assets/_static/welcome_w2.png"),
  require("@data/assets/_static/welcome_w3.png"),
];

const MainNoti = ({ onEnd, onClick }) => {
  const wrapperRef = useRef(null);
  const imagesLoaded = useOnLoadImages(wrapperRef);
  const welcomeSound =
    window.__welcomeRandom[0] === true
      ? ms[window.__welcomeRandom[1]]
      : ws[window.__welcomeRandom[1]];

  const welcomeImg =
    window.__welcomeRandom[0] === true
      ? char_m[window.__welcomeRandom[1]]
      : char_w[window.__welcomeRandom[1]];

  useEffect(() => {
    if (imagesLoaded) {
      wrapperRef.current.classList.add("on");
      loading(false);

      anime({
        targets: "#notiChar",
        opacity: [0, 1],
        scale: [0, 1],
        duration: 700,
        easing: "easeOutBack",
        delay: 100,
      });

      anime({
        targets: "#notiText",
        opacity: [0, 1],
        translateY: [200, 0],
        duration: 500,
        easing: "easeOutBack",
        delay: 500,
      });

      anime({
        targets: "#notiEffect",
        opacity: [0, 1],
        scaleX: [2, 1],
      });

      playSound.word(welcomeSound).then(() => {
        onEnd();
      });
    } else {
      loading();
    }
    return () => {
      anime.remove("#notiChar");
      anime.remove("#notiText");
      anime.remove("#notiEffect");
      playSound.wordStop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagesLoaded]);
  return (
    <Wrap ref={wrapperRef} onClick={onClick}>
      <img
        src={require("@data/assets/_static/main_welcome_text.png")}
        alt=""
        className="text"
        id="notiText"
      />
      <img src={welcomeImg} alt="" className="char" id="notiChar" />
      <img
        src={require("@data/assets/_static/main_welcome_effect.png")}
        alt=""
        className="effect"
        id="notiEffect"
      />
    </Wrap>
  );
};

export default MainNoti;
